// src/pages/public/NotFound.jsx
// FASE 2.C — P-06 404 (pixel-perfect del mockup v4).
// Source: entregable_claude/screens_public.jsx líneas 186-207.
// Conversión: prop go → useNavigate(); botón principal → '/', "Iniciar sesión" → '/login',
// "Contactar soporte" → '/soporte'.
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="mobile-root">
      <Helmet>
        <title>404 · Edge Elite</title>
      </Helmet>

      <section
        className="screen"
        style={{
          paddingTop: 80,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          paddingBottom: 40,
        }}
      >
        <div
          className="num"
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 120,
            fontWeight: 800,
            letterSpacing: '-0.06em',
            lineHeight: 1,
            color: 'var(--accent)',
            marginBottom: 18,
          }}
        >
          404
        </div>

        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 26,
            fontWeight: 700,
            letterSpacing: '-0.025em',
            margin: 0,
            marginBottom: 10,
          }}
        >
          Esta jugada no existe
        </h2>
        <p
          style={{
            fontSize: 14,
            color: 'var(--muted)',
            margin: 0,
            marginBottom: 32,
            maxWidth: 320,
            lineHeight: 1.5,
          }}
        >
          La página que buscas no está disponible o se movió. Volvamos a un terreno conocido.
        </p>

        <button
          className="btn-primary accent"
          style={{ maxWidth: 280 }}
          onClick={() => navigate('/')}
        >
          Ir al inicio
        </button>

        <div style={{ marginTop: 28, display: 'flex', gap: 16, fontSize: 13 }}>
          <a
            onClick={() => navigate('/login')}
            style={{
              color: 'var(--ink)',
              fontWeight: 600,
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Iniciar sesión
          </a>
          <span style={{ color: 'var(--muted)' }}>·</span>
          <a
            onClick={() => navigate('/soporte')}
            style={{
              color: 'var(--ink)',
              fontWeight: 600,
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Contactar soporte
          </a>
        </div>
      </section>
    </div>
  );
}
